const BLACK_LIST = ['00000000000', '99999999999']
const validate = cpf => {
	var sum
	var rest
	sum = 0
	if (BLACK_LIST.includes(cpf)) return false

	for (var i = 1; i <= 9; i++)
		sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i)
	rest = (sum * 10) % 11

	if (rest == 10 || rest == 11) rest = 0
	if (rest != parseInt(cpf.substring(9, 10))) return false

	sum = 0
	for (var i = 1; i <= 10; i++)
		sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i)
	rest = (sum * 10) % 11

	if (rest == 10 || rest == 11) rest = 0
	if (rest != parseInt(cpf.substring(10, 11))) return false
	return true
}

export { validate }
